// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.FilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class FilterValueBase {
  /** Do NOT invoke directly, instead use strongly typed createFilterValueBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.FilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initFilterValue(json.componentGuid != null ? json.componentGuid : null);
  }
  initFilterValue(componentGuid) {
    this._componentGuid = componentGuid;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._componentGuid != null) {
      retVal["componentGuid"] = this._componentGuid;
    }
    return retVal;
  }
  get componentGuid() {
    return this._componentGuid;
  }
  set componentGuid(value) {
    this._componentGuid = value;
  }
}
//# sourceMappingURL=FilterValueBase.js.map
